import type { SerializedConstructor } from '@langchain/core/load/serializable';

import { parseLangSmithParamsFromRun } from '@/utils/langsmith-params';

import type { ManifestPreviewProps } from '../../Manifest.utils';

export const MODELS = ['deepseek-chat', 'deepseek-reasoner'].map((value) => ({
  label: value,
  value,
}));

export const DEFAULT_MODEL = 'deepseek-reasoner';

export function useChatDeepSeekModelAndProvider(
  props: ManifestPreviewProps<SerializedConstructor>
) {
  const id = props.value.id.at(-1) ?? '';
  const kwargs = props.value.kwargs;
  const model = kwargs.model ?? DEFAULT_MODEL;

  return {
    model,
    provider: id,
  };
}

export function inferChatDeepSeekManifestFromRun(
  params: ReturnType<typeof parseLangSmithParamsFromRun>,
  serializedModel: SerializedConstructor | null
): SerializedConstructor | null {
  if (
    params?.ls_provider !== 'deepseek' ||
    !(params?.ls_model_type == null || params.ls_model_type === 'chat')
  ) {
    return null;
  }

  const clientOptions = serializedModel?.kwargs.client_options;

  return {
    lc: 1,
    type: 'constructor',
    id: ['langchain', 'chat_models', 'deepseek', 'ChatDeepSeek'],
    kwargs: {
      ...(params.ls_model_name && {
        model: params.ls_model_name,
      }),
      ...(params.ls_temperature && {
        temperature: params.ls_temperature,
      }),
      ...(params.ls_max_tokens && {
        max_tokens: params.ls_max_tokens,
      }),
      ...clientOptions,
      client_options: undefined,
    },
  };
}
